import NewTransferRequisitions from "../../../../components/@documents/transfer_requisitions/NewTransferRequisition";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferRequisitionNewPage() {

    return (
        <NewTransferRequisitions 
            routeType={routeTypes.retail}
        />
    )
}